import { useState, useEffect, useRef } from 'react';
import './Information.css';
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/Footer';
import Button from 'react-bootstrap/Button';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
// import SubLoader from '../../components/SubLoader/SubLoader'
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { toast } from 'react-toastify';

const Information = () => {
    const [visible, setVisible] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false);
    const [isCSVLoading, setIsCSVLoading] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [hasMoreData, setHasMoreData] = useState(true);
    const loaderRef = useRef(null);
    const item_per_page = 30;
    const token = localStorage.getItem('authToken');

    const historyApi = async (page) => {
        setIsHistoryLoading(true);
        try {
            const api = `${process.env.REACT_APP_API_LINK}/api/v1/admin/getFileLoadingHistory?items=${item_per_page}&pageNo=${page}`;
            const response = await axios.get(api, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const newData = response.data || [];

            // Append, not replace
            setApiData(prev => [...prev, ...newData]);

            // If less than 30 items returned, no more data
            if (newData.length < 30) {
                setHasMoreData(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            setIsHistoryLoading(false);
        }
    };

    const handleDialogOpen = () => {
        setVisible(true);
        setPageNo(1);
        setApiData([]);
        setHasMoreData(true);
    };

    const handleExportCSV = async () => {
        try {
            setIsCSVLoading(true);
    
            const api = `${process.env.REACT_APP_API_LINK}/api/v1/document/getExportCsv`;
    
            const response = await axios.get(api, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            // console.log(response.data);
    
            toast.success(`CSVs are saved successfully`);
    
        } catch (error) {
            console.error(error);
        } finally {
            setIsCSVLoading(false);
        }
    };

    useEffect(() => {
        if (visible && pageNo === 1) {
            historyApi(1);
        }
    }, [visible]);

    // Intersection Observer for infinite scroll
    useEffect(() => {
        if (!hasMoreData || isHistoryLoading) return;

        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    setPageNo(prev => prev + 1);
                }
            },
            { threshold: 1 }
        );

        const currentLoader = loaderRef.current;
        if (currentLoader) observer.observe(currentLoader);

        return () => {
            if (currentLoader) observer.unobserve(currentLoader);
        };
    }, [hasMoreData, isHistoryLoading]);

    useEffect(() => {
        if (pageNo > 1) {
            historyApi(pageNo);
        }
    }, [pageNo]);

    return (
        <div className='information_main_outer'>
            <Header />
            <div className="information_main">
                <div className="tabs_both">
                    <div className="tabs"></div>
                    <div className="tabs1">
                        <Button variant="outline-secondary" onClick={handleExportCSV} className='button_export'>
                            {isCSVLoading ? <div id="loading_both">
                                <i id="spinner" className="fa fa-spinner fa-spin"></i>
                            </div> :
                                "Export CSV"
                            }

                        </Button>
                        <Button variant="outline-secondary" onClick={handleDialogOpen}>
                            History
                        </Button>
                        <Dialog
                            header="Information.."
                            className="popup_box"
                            visible={visible}
                            onHide={() => setVisible(false)}
                            headerStyle={{ border: '2px solid white', padding: '0% .6% 0% 5%' }}
                        >
                            <div id="history_btn_details">
                                {apiData.map((item, index) => (
                                    <div className="list_history" key={index}>
                                        <div id="inside_list_history">
                                            <span className="sub_list"><strong>S.No</strong></span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2"><strong>{index + 1}</strong></span>
                                        </div>
                                        <div id="inside_list_history">
                                            <span className="sub_list">ID</span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2">{item.id}</span>
                                        </div>
                                        <div id="inside_list_history">
                                            <span className="sub_list">FileName</span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2">{item.file_name}</span>
                                        </div>
                                        <div id="inside_list_history">
                                            <span className="sub_list">Success</span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2">
                                                <span
                                                    id={
                                                        item.success === true
                                                            ? 'success_color'
                                                            : 'success_color_1'
                                                    }
                                                >
                                                    {item.success === true ? 'True' : 'False'}
                                                </span>
                                            </span>
                                        </div>
                                        <div id="inside_list_history">
                                            <span className="sub_list">Error</span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2">
                                                {(() => {
                                                    let final_error;
                                                    if (item.error.includes('sqlMessage')) {
                                                        const searchOne = item.error.indexOf('sqlMessage');
                                                        const searchTwo = item.error.indexOf('"sql":');
                                                        final_error = item.error.substring(searchOne + 13, searchTwo - 2);
                                                    } else {
                                                        final_error = item.error;
                                                    }
                                                    return final_error || 'No error message';
                                                })()}
                                            </span>
                                        </div>
                                        <div id="inside_list_history">
                                            <span className="sub_list">CreatedAt</span>
                                            <span className="sub_list_1">:</span>
                                            <span className="sub_list_2">
                                                {(() => {
                                                    const date = new Date(item.createdAt);

                                                    const day = String(date.getDate()).padStart(2, "0");
                                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                                    const year = date.getFullYear();

                                                    let hours = date.getHours();
                                                    const minutes = String(date.getMinutes()).padStart(2, "0");
                                                    const ampm = hours >= 12 ? "PM" : "AM"; // ✅ CAPITAL AM/PM

                                                    hours = hours % 12 || 12; // 0 → 12

                                                    return `${day}-${month}-${year} , ${hours}:${minutes} ${ampm}`;
                                                })()}
                                            </span>
                                        </div>
                                    </div>
                                ))}

                                {/* Loader and scroll trigger */}
                                {hasMoreData && (
                                    <div ref={loaderRef} className="history_loader">
                                        <Loader />
                                    </div>
                                )}
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
            <Footer className="footer" />
        </div>
    );
};

export default Information;
